import React from 'react';

import './PersonalFeedback.scss';
import Participant from '../../../partials/Participant/Participant';

const PersonalFeedback = props => {
    console.log("personal feedback")
    console.log(props);

    return (
        // 
        <div className={`personal-feedback ${props.speakerView}`}>
            {/* for the image, we will use the team of the person talking to determine the color by either directly accessing the JSON or using it to apply a class */}
            <div>
                {props.teamMember && <Participant hasNameTag={true} teamMember={props.teamMember}/>}
            </div>
            <div className='content-container'>

                {/* here we will render the feedback text from the JSON
                        -depending on whether this is an introduction or feedback during a team presentation will determine things like flex direction, and whether or not there will be a 'Respond' button*/}
                {props.children}

            </div>

        </div>
    )
}

export default PersonalFeedback;